<template>
    <div ref="parent" class="input input--decisions r v--20">
        
        <span
            v-if="field.field_label"
            :class="labelClass"
            v-html="field.field_label">
        </span>

        <div v-if="pulledInputs !== undefined || pulledInputs !== null" class="decisions__list c c--content--pad r v--25">

            <div v-for="(f, index) in pulledInputs" :key="index" class="decisions__list__item r v--15" :data-key="index">

                <div class="decisions__list__item__impulsive r v--5">
                    <label :for="inputId(index + '_imp')">
                        <strong>Impulsive decision:</strong>
                    </label>
                    <input
                        type="text"
                        :value="f"
                        :id="inputId(index + '_imp')"
                        readonly
                        data-impulsive
                        >
                </div>
                <div class="decisions__list__item__thoughtful r v--10">
                    <label :for="inputId(index + '_tho')">
                        <strong>Thoughtful decision:</strong>
                    </label>
                    <input
                    type="text"
                    :value="getTextFieldValue(index)"
                    :data-push-key="field.push_key"
                    :id="inputId(index + '_tho')"
                    placeholder=""
                    maxlength="250"
                    @keyup="$emit('validate')"
                    data-watch-event="keyup"
                    data-pristine-not-blank
                    required
                    data-thoughtful
                    >
                </div>

            </div>

        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            pulledInputs: this.field.pull_input_data !== "" ? this.siloData.user.modules[this.field.pull_input_data] : null,
            currentChecked: "",
        }
    },
    props: {
        field: Object,
        siloData: Object,
    },
    computed: {
        labelClass() {
            let returned = "";

            if (this.field.hide_label === true) {
                returned += " screen-reader-only";
            }

            if (this.field.label_class !== undefined) {
                returned += " " + this.field.label_class;
            } else {
                returned += " type--label";
            }

            return returned;
        },
        checkToHide() {
            // Assume we don't want to hide
            let returned = false;
            // If we are pulling inputs start the check
            if (this.pulledInputs !== null && this.pulledInputs !== undefined) {
                // Pull the inputs
                let inputs = this.siloData.user.modules[this.field.pull_input_data];
                // If there are one or less inputs, hide everything because
                // it doesn't make sense to have just one checkbox (for now)
                if (inputs.length < 2) {
                    returned = true;
                }
            }
            return returned
        },
    },
    watch: {
      siloData() {
        // If we don't have pulled checkbox data set up, just return
        // Otherwise, this will wipe out all of our manually entered checkbox data on silo data refresh
        if (this.field.pull_input_data !== undefined) {
            this.pulledInputs = this.siloData.user.modules[this.field.pull_input_data];
        }
      }, 
      field() {
        if (this.pulledInputs !== null) {
            this.$emit('validate');
        }
      }, 
    },   
    mounted() {
        this.$nextTick(()=>{
            // TODO: FIll in fields with entered content
            //this.fillOtherValue();
            //this.setCurrentChecked();
        });
    },    
    destroyed(){
        //console.log('Checkboxes Destroyed!');
        this.pulledInputs = null;
    },
    methods: {
        setCurrentChecked() {
            this.currentChecked = this.getSelected();
            console.log('setting current checked', this.currentChecked);
        },
        getSelected() {
            return this.$refs.parent.querySelector("input:checked") ? this.$refs.parent.querySelector("input:checked").value : "";
        },
        getTextFieldValue(index) {
            return this.siloData.user.modules[this.field.push_key] ? this.siloData.user.modules[this.field.push_key][index] : "";
        },
        // Get a slug
        getSlug(str) {
            return window.utils.methods.sluggify(str)
        },
        onChangeEvent(event) {
            console.log('and change event fired');
            // validate field
            this.$emit('validate');
        },        
        inputId(index) {
            return this.field.push_key + '-' + this.field.panels_info.widget_id + index;
        },
    }, 
}
</script>
<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

input[type="text"][readonly] {
    border: 0;
    padding: 0;
    box-shadow: inherit !important;
    min-height: inherit;
}

</style>